import { Component, ViewEncapsulation } from '@angular/core';
import { BaseModalComponent } from '../../../models/base-modal-component';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { CommonService } from '../../../services/common/common.service';

@Component({
  standalone: false,
  selector: 'res-policy-acknowledgment-modal',
  templateUrl: './policy-acknowledgment-modal.component.html',
  styleUrls: ['./policy-acknowledgment-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class PolicyAcknowledgmentModalComponent extends BaseModalComponent {

  modalClass = 'policy-acknowledgment-modal';
  modalAutomationId = 'policy-acknowledgment';
  primaryButtonLabel = 'Continue';

  privacyPolicyUrl: string;
  acceptPrivacyPolicy: boolean = false;
  acceptEndUserLicenseAgreement: boolean = false;

  constructor(private modalService: BsModalService, private policyAcknowledgmentModalRef: BsModalRef, private commonService: CommonService) {
    super(modalService, policyAcknowledgmentModalRef);
    this.privacyPolicyUrl = this.commonService.privacyPolicyUrl;
  }

  continue(): void {
    this.closeModal(true);
  }

  continueEnabled(): boolean {
    return this.acceptPrivacyPolicy && this.acceptEndUserLicenseAgreement;
  }
}